import { Image } from 'antd'
import cn from 'classnames'
import { FC } from 'react'

import { CoinIconMap } from '@/lib/coin'

import s from './index.scss'

export interface ICoinIcon {
  symbol?: string | any
  size?: number
  className?: string
}

const CoinIcon: FC<ICoinIcon> = (props) => {
  const { symbol, size = 32, className } = props
  return typeof symbol !== 'string' || CoinIconMap[symbol!] ? (
    <Image
      preview={false}
      className={cn(className, 'f0')}
      src={symbol?.default || CoinIconMap[symbol!]}
      alt=""
      height={size}
      width={size}
      style={{ width: size, height: size }} //处理形变提出的UI问题
    />
  ) : (
    <div className={s.defaultIcon}>{symbol?.slice(0, 1) || ''}</div>
  )
}
export default CoinIcon
